const getters = {
  user: state => state.user,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  certificationObj: state => state.app.certificationObj
}
export default getters